import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import shareLinkService from "../services/shareLinkService";

/**
 * Récupère le jeton d'affiliation passé dans l'URL (`?aff=`).
 *
 * L'aperçu de lien (`api/share.js`) résout déjà le code de partage côté serveur
 * pour rendre les balises Open Graph : il connaît le jeton avant même que la
 * page ne s'ouvre, et le transmet plutôt que de laisser l'application le
 * redemander — un aller-retour de moins avant l'affichage du produit.
 *
 * Le paramètre est retiré de la barre d'adresse aussitôt lu : un lien
 * re-partagé depuis là ne doit pas recopier le jeton d'un autre affilié, ce qui
 * lui attribuerait des commissions qui ne sont pas les siennes.
 */
const useAffiliateParam = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("aff");
    if (!token) return;

    shareLinkService.setAffiliateToken(token);

    params.delete("aff");
    const query = params.toString();
    navigate(`${location.pathname}${query ? `?${query}` : ""}${location.hash}`, {
      replace: true,
    });
  }, [location.pathname, location.search, location.hash, navigate]);
};

export default useAffiliateParam;
